import { postSuccessTransaction } from '../api/postSuccessTransaction';

const setPostSuccessTransaction = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            await postSuccessTransaction(params);
            if (callback) {
                callback()
            }
        } catch(error) {
            alert('Ошибка');
            if (callback) {
                callback()
            }
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostSuccessTransaction
}